import * as React from 'react';
import { Typography } from '@mui/material'
import { ID_CREDIT_NOTE } from "../constants/InvoicesTypes";
import { useTranslation } from "react-i18next";
import InvoiceSimpleTable, { SimpleColumnDef } from "../../../component/InvoiceSimpleTable";
import { formatCurrency } from "../../../utils/FormatUtils";

const InvoiceTaxes = (props: { invoice: any, type?: string }) => {

    const { t } = useTranslation('finance', { keyPrefix: 'invoices' });

    const columnDefs: SimpleColumnDef[] = [
        {
            field: 'rate',
            headerName: t("preview.tables.taxes.vat-rate"),
            width: '40%',
            valueFormatter: (data) => {
                return {
                    component: () => {
                        if (data.type === "TOTAL") {
                            return <Typography align={'left'} fontWeight={600} sx={{ paddingTop: "2ch" }}>{data.rate}</Typography>
                        }
                        let description = props.invoice.items.find((invoiceItem: any) => invoiceItem.taxType.value === data.rate)?.taxType?.description || data.rate;
                        return <Typography align={'left'} fontWeight={400}>{description}</Typography>
                    }
                }
            }
        },
        {
            field: 'totalNetPrice',
            headerName: t("preview.tables.taxes.net-amount"),
            width: "14%",
            cellStyle: 'right',
            valueFormatter: (data) => {
                return {
                    component: () => {
                        if (data.type === "TOTAL") {
                            return (
                                    <Typography align={'right'} fontWeight={600} sx={{ paddingTop: "2ch" }}>
                                        {formatCurrency(data.totalNetPrice, props.invoice.currency, 0.01) + (data.totalDiscount !== 0 && data.totalDiscount !== undefined ? ` (-${formatCurrency(data.totalDiscount, props.invoice.currency, 0.01)})` : "")}
                                    </Typography>
                            )
                        } else {
                            return (
                                    <Typography align={'right'} fontWeight={400}>
                                        {formatCurrency(data.totalNetPrice, props.invoice.currency, 0.01) + (data.totalDiscount !== 0 && data.totalDiscount !== undefined ? ` (-${formatCurrency(data.totalDiscount, props.invoice.currency, 0.01)})` : "")}
                                    </Typography>
                            )
                        }
                    }
                }
            }
        },
        {
            field: 'totalVat',
            headerName: t("preview.tables.taxes.tax-amount"),
            width: "13%",
            cellStyle: 'right',
            valueFormatter: (data) => {
                return {
                    component: () => {
                        if (data.type === "TOTAL") {
                            return <Typography align={'right'} fontWeight={600} sx={{ paddingTop: "2ch" }}>{formatCurrency(data.totalVat, props.invoice.currency, 0.01)}</Typography>
                        } else {
                            return <Typography align={'right'} fontWeight={400}>{formatCurrency(data.totalVat, props.invoice.currency, 0.01)}</Typography>
                        }
                    }
                }
            }
        },
        {
            field: 'totalGrossPrice',
            headerName: t("preview.tables.taxes.total-amount"),
            width: "13%",
            cellStyle: 'right',
            valueFormatter: (data) => {
                return {
                    component: () => {
                        if (data.type === "TOTAL") {
                            return <Typography align={'right'} fontWeight={600} color={'accent.main'}
                                               sx={{ paddingTop: "2ch" }}>{formatCurrency(data.totalGrossPrice, props.invoice.currency, 0.01)}</Typography>
                        } else {
                            return <Typography align={'right'} fontWeight={400}>{formatCurrency(data.totalGrossPrice, props.invoice.currency, 0.01)}</Typography>
                        }
                    }
                }
            }
        }
    ];

    const footer = {
        rate: props.invoice.documentType === ID_CREDIT_NOTE || props.type === ID_CREDIT_NOTE ? t("preview.tables.taxes.total-credit-label") : t("preview.tables.taxes.total-debit-label"),
        totalNetPrice: props.invoice.totalNetPrice,
        totalVat: props.invoice.totalVat,
        totalGrossPrice: props.invoice.totalGrossPrice,
        totalDiscount: props.invoice.documentType === ID_CREDIT_NOTE || props.type === ID_CREDIT_NOTE ? 0 : props.invoice.totalDiscount,
        type: "TOTAL"
    }

    return (
            <InvoiceSimpleTable columnDefs={columnDefs} data={[...props.invoice.vatRate, footer]}/>
    )
}
export default InvoiceTaxes;